import type { ClientBranding } from "../../../../../shared/api/clientBranding";

/** Resolved branding used by slide renderers and the print/present views. */
export interface ReportBranding {
  primaryColor: string;
  chartColor: string;
  /** Client logo shown on slides (top-right, like the deck). Null → PEAK4 only. */
  logoUrl: string | null;
}

// Deck defaults (PEAK4 dark theme) when a client hasn't set branding.
const DEFAULT_PRIMARY = "#4DD0E1";
const DEFAULT_CHART = "#4DD0E1";

/**
 * Resolve a client's branding into the values slide renderers need, preferring
 * the dark-theme variants (report slides are always dark, matching the deck).
 */
export const resolveBranding = (
  branding?: ClientBranding | null,
): ReportBranding => ({
  primaryColor:
    branding?.dark_primary_color || branding?.primary_color || DEFAULT_PRIMARY,
  chartColor:
    branding?.dark_chart_primary_color ||
    branding?.chart_primary_color ||
    branding?.dark_primary_color ||
    branding?.primary_color ||
    DEFAULT_CHART,
  logoUrl:
    branding?.dark_logo_url ||
    branding?.logo_dark_url ||
    branding?.logo_url ||
    null,
});
